export const OMNICHANNEL_COMPOSER_FILES_EVENT =
  "spaik:omnichannel-composer-files";

const hasFileType = (types?: readonly string[] | DOMStringList) => {
  if (!types) return false;

  return Array.from(types).includes("Files");
};

export const extractFilesFromDataTransfer = (dataTransfer?: DataTransfer | null) => {
  if (!dataTransfer) return [];

  return Array.from(dataTransfer.files ?? []).filter((file) => file.size >= 0);
};

export const extractFilesFromClipboard = (
  clipboardData?: DataTransfer | null
) => {
  if (!clipboardData) return [];

  if (clipboardData.files?.length) {
    return Array.from(clipboardData.files);
  }

  return Array.from(clipboardData.items ?? [])
    .filter((item) => item.kind === "file")
    .map((item) => item.getAsFile())
    .filter((file): file is File => Boolean(file));
};

export const dataTransferHasFiles = (dataTransfer?: DataTransfer | null) =>
  hasFileType(dataTransfer?.types) || extractFilesFromDataTransfer(dataTransfer).length > 0;

export const clipboardHasFiles = (clipboardData?: DataTransfer | null) =>
  hasFileType(clipboardData?.types) || extractFilesFromClipboard(clipboardData).length > 0;

export const emitOmnichannelComposerFiles = (files: File[]) => {
  if (!files.length) return;

  window.dispatchEvent(
    new CustomEvent(OMNICHANNEL_COMPOSER_FILES_EVENT, {
      detail: { files }
    })
  );
};

export interface OmnichannelComposerFilesEventDetail {
  files: File[];
}
